import { Component, OnInit, Input } from '@angular/core';
import { SharedRankingListService } from './shared-ranking-list.service';

@Component({
    selector: 'app-shared-ranking-list',
    templateUrl: './shared-ranking-list.component.html',
    styleUrls: ['./shared-ranking-list.component.scss'],
})
export class SharedRankingListComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto
     */
    @Input() departmentType: any;
    /**
     * Definição da identificão path do route
     * Ex: kids, youth, ...
     */
    @Input() pathRoute: string;
    linkRoute: string;

    /**
     * Definição de filtros para busca de rankings
     */
    @Input() filterRankingYear: string = '2020';

    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any;

    list: any;
    filters: any;
    loadAll = 1;
    loading: boolean = false;

    constructor(private sharedRankingListService: SharedRankingListService) {}

    ngOnInit(): void {
        this.linkRoute = '/' + this.pathRoute + '/ranking-classif';
        this.rankingList();
    }

    /**
     * rankingList() - Buscar lista de rankings de um ano selecionado
     */
    rankingList(filters = null) {
        this.loading = true;
        this.sharedRankingListService.getRankingsFilter(this.departmentType, filters).subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * onFilterChange(): Ao mudar parãmetro de filtro
     * @param event Objeto com parâmetros selecionados/alterado através do filtro
     */
    onFilterChange(event) {
        this.rankingList(event);
        /**
         * TODO: fix me
         */
        this.loadAll = event.loadAll;
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        this.list = this.loadAll ? response.registers.list : this.list;
        this.filters = response.registers.filters;
        this.loading = false;
        console.log(this.list);
        console.log(this.statusCode);
        //console.log(this.filters);
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
        this.loading = false;
    }
}
